{
  "manage": {
    "activity_titles": "Gérer les titres d'activité"
  },
  "user_menu": {
    "logged_in_as": "Vous êtes connecté en tant que",
    "switch_account": "Changer de compte",
    "updated_contacts": "Contacts mis à jour",
    "help": "Aide",
    "individual_connect": "Connexion individuelle",
    "admin_connect": "Connexion administrateur ({{consentName}})"
  },
  "permission_section": {
    "contacts": "Contacts",
    "companies": "Entreprises",
    "prospects": "Prospects",
    "opportunities": "Opportunités",
    "objectives": "Objectifs",
    "employee": "Employé",
    "workspaces_and_apps": "Espaces de travail et applis",
    "marketing_lists": "Listes marketing",
    "referral_tracking": "Suivi des recommandations",
    "interactions": "Interactions",
    "research_reports": "Rapports de recherche"
  },
  "user_management": {
    "users": {
      "add_user": "Ajouter un utilisateur",
      "edit_user": "Modifier l'utilisateur",
      "users_tab": "Utilisateurs",
      "delegate_access": "Vérifier les accès délégués de {{profileName}}",
      "delegate_account": "Compte délégué",
      "main_account": "Compte principal"
    },
    "roles": {
      "add_role": "Ajouter un rôle",
      "roles_tab": "Rôles",
      "base_role": "Rôle de base",
      "individual_lawyer": "Avocat individuel"
    },
    "forms": {
      "name": "Nom",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "email": "Courriel",
      "role": "Rôle",
      "description": "Description",
      "edit": "Modifier {{profileName}}",
      "delete": "Supprimer {{delegateUserName}}",
      "select_role": "Sélectionner un rôle",
      "type_first_name": "Saisir le prénom",
      "type_last_name": "Saisir le nom de famille",
      "type_email": "Saisir l'courriel",
      "type_role_name": "Saisir le nom du rôle",
      "describe_role": "Décrire le rôle"
    },
    "validation": {
      "please_select_role": "Veuillez sélectionner un rôle",
      "please_enter_valid_email": "Veuillez saisir un courriel valide",
      "name_required": "Le nom est requis"
    },
    "confirmations": {
      "delete_user_title": "Supprimer l'utilisateur",
      "delete_user_content": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
      "delegate_access_caption": "Attribuer l'accès utilisateur délégué au compte principal."
    }
  },
  "access_role_permission_form": {
    "role_description": "Description du rôle - {{description}}"
  },
  "permissions": {
    "viewMyContacts": "Voir mes contacts",
    "exportMyContacts": "Exporter mes contacts",
    "viewAllContacts": "Voir tous les contacts",
    "exportAllContacts": "Exporter tous les contacts",
    "viewContactRecords": "Voir les enregistrements de contact",
    "viewContactWhoKnows": "Voir qui connaît le contact",
    "viewLastInteractionDateUser": "Voir la date de dernière interaction utilisateur",
    "viewLastInteractionDateFirm": "Voir la date de dernière interaction cabinet",
    "viewContactEmailAddresses": "Voir les adresses courriel de contact",
    "viewContactActivities": "Voir les activités de contact",
    "viewMyCompanies": "Voir mes entreprises",
    "exportMyCompanies": "Exporter mes entreprises",
    "viewAllCompanies": "Voir toutes les entreprises",
    "exportAllCompanies": "Exporter toutes les entreprises",
    "viewCompanyRecords": "Voir les enregistrements de entreprise",
    "viewCompanyWhoKnows": "Voir qui connaît la entreprise",
    "viewMyProspects": "Voir mes prospects",
    "viewAllProspects": "Voir tous les prospects",
    "viewMyOpportunities": "Voir mes opportunités",
    "viewAllOpportunities": "Voir toutes les opportunités",
    "exportAllOpportunities": "Exporter toutes les opportunités",
    "viewMyObjectives": "Voir mes objectifs",
    "viewAllObjectives": "Voir tous les objectifs",
    "viewEmployeeEngagementTab": "Voir l'onglet engagement employé",
    "viewEmployeeOpportunitiesTab": "Voir l'onglet opportunités employé",
    "exportCompanyLists": "Exporter les listes de entreprises",
    "exportContactLists": "Exporter les listes de contacts",
    "exportGenericLists": "Exporter les listes génériques",
    "exportKeyActivityLists": "Exporter les listes d'activités clés",
    "exportOpportunities": "Exporter les opportunités",
    "exportAllActivities": "Exporter toutes les activités",
    "exportMarketingLists": "Exporter les listes marketing",
    "exportReferrals": "Exporter les recommandations",
    "readCompanyReport": "Lire le rapport de entreprise",
    "editCompanyReport": "Modifier le rapport de entreprise"
  },
  "access_role_page": {
    "user_management": "Gestion des utilisateurs"
  },
  "settings": {
    "language": "Langue"
  },
  "delete_role": {
    "confirm_content": "Êtes-vous sûr de vouloir supprimer ce rôle ? Cette action est irréversible."
  },
  "access_role_table": {
    "role": "Rôle",
    "description": "Description"
  },
  "switch_account": {
    "select_user": "Sélectionnez le compte avec lequel vous souhaitez vous connecter"
  },
  "account_colour": {
    "select_colour": "sélectionner la couleur du compte"
  },
  "callback": {
    "authenticated": "Authentifié !",
    "redirecting_message": "Nous travaillons à vous rediriger vers le bon endroit..."
  }
}
